import HARDCODE from '../../../business-const/HardCode/HardCode'

export const aumentoLetraGarantias = (values, detalhadoTipoRecurso) => {

    const aumentoLetraCabecalho = 2 - (detalhadoTipoRecurso ? 2 : 0)
    const aumentoLetraReportCabecalho = values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ? 1 : 2

    const aumentoLetra = 3 - (detalhadoTipoRecurso ? 4 : 0)
    const aumentoLetraReport = (values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ? 2 : 3) -
        (detalhadoTipoRecurso ? 2 : 0) 

    const aumentoLetraTotal = 0 - (detalhadoTipoRecurso ? 3 : 0)
    const aumentoLetraTotalReport = (values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ? 1 : 2) -
        (detalhadoTipoRecurso ? 1 : 0) 

    return { aumentoLetraCabecalho, aumentoLetraReportCabecalho, aumentoLetra, aumentoLetraReport,
        aumentoLetraTotal, aumentoLetraTotalReport }
}

export const ajusteAumentoLetraGarantiasDescricao = (values, descricao) => {

    descricao = descricao.trim()

    return (
        values.modoApresentacao || values.disposicaoRelatorio !== HARDCODE.disposicaoRelatorioRetrato
            ?
                0
            :
                values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato && descricao.length > 45
                    ?
                        -3
                    :
                        values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato && descricao.length > 36
                            ?
                                -2
                            :
                                values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato && descricao.length > 33
                                    ?
                                        -1
                                    :
                                        0
    )
}

export const espacoAdcionalAjusteAumentoLetraGarantiasDescricao = (values, descricao) => {

    return (
        values.modoApresentacao || values.disposicaoRelatorio !== HARDCODE.disposicaoRelatorioRetrato
            ?
                ''
            :
                values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato && descricao.length > 45
                    ?
                        '    '
                    :
                        values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato && descricao.length > 36
                            ?
                                '   '
                            :
                                values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato && descricao.length > 33
                                    ?
                                        ' '
                                    :
                                        ''
    )
}

/*
export const ajusteAumentoLetraGarantiasValor = (values, valor) => {

    return values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato && valor > 100000000 ? -1 : 0
}
*/